import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {appHeader_template} from "../components/templates/appHeader_template";
import {vnApp_sentinelbi} from "../components/vnApp_sentinelbi";

declare var page: any;
declare var ko: any;

export class header extends vnModule_knockoutJS {

    protected getModuleName(){
        return "header";
    }

    public appHeader: appHeader_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent() : Array<Element>{

        let vnApp : vnApp_sentinelbi = <vnApp_sentinelbi>this.getVnAppZone().app;

        if(vnApp.loggedUser.isLoggedIn) {

            this.appHeader = new appHeader_template("mainHeader", this.viewModel, this);

            this.appHeader.setDevice(this.getVnAppZone().getCookie('device'));
            this.appHeader.setDeviceView(this.getVnAppZone().getCookie('deviceView'));

            this.appHeader.setUser(vnApp.loggedUser);

            if (vnApp.isDashboard()) {
                this.appHeader.setIsUserSectionVisible(false);
            }else {
                this.appHeader.setIsUserSectionVisible(true);
            }

            if(vnApp.isOfRole(vnApp_sentinelbi.ROLE_ADMINISTRATOR) || vnApp.isDashboard()) {

                this.appHeader.setIsLogsVisible(true);
            }

            // for the plan promo popup
            if(vnApp.isOfRole(vnApp_sentinelbi.ROLE_OWNER) || vnApp.isOfRole(vnApp_sentinelbi.ROLE_ADMINISTRATOR)){

                this.appHeader.setIsOwnerOrAdmin(true);
            }

            // set picture
            if (vnApp.loggedUser.user.vnAppUser.pictureUrl) {
                this.appHeader.setUserImageSrc("/usersImages/" + vnApp.loggedUser.user.pictureUrl);
            }
            else {
                this.appHeader.setUserImageSrc("/assets/images/default-user.png");
            }

            // set full name
            this.appHeader.setUserFullName(vnApp.loggedUser.user.vnAppUser.firstName + ' ' + vnApp.loggedUser.user.vnAppUser.lastName);

            // set profile page link
            this.appHeader.setProfilePageLink("/users/edit/" + vnApp.loggedUser.user.id);

            return [this.appHeader.build()]
        } else {
            return [];
        }
    }

    public processReleaseLogs(releaseLogs: any[]){

        try {
            let cookieString = this.getVnAppZone().getCookie('readReleaseLogs');

            if(!cookieString) {

                this.appHeader.setReleaseLogsToShow(releaseLogs);
                return;
            }
            
            let readReleaseLogIds = cookieString.split(',').map(id => Number.parseInt(id));
            releaseLogs = releaseLogs.filter(rl => !readReleaseLogIds.includes(rl.id))

            this.appHeader.setReleaseLogsToShow(releaseLogs);
        } catch(e) {

            console.warn('Issue with processing release logs');
        }
    }    

    public fillPage() : void{
        let vnApp : vnApp_sentinelbi = <vnApp_sentinelbi>this.getVnAppZone().app;

        if(vnApp.loggedUser.isLoggedIn && !vnApp.isDashboard()) {

            let accountSettingsUrlReq_url: string = '/api/settings/url/get/';
            let accountSettingsUrlReq_params: Array<Array<string>> = [];

            let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(accountSettingsUrlReq_url, accountSettingsUrlReq_params, this);

            XHRHdl.onReadyStateFunction = (function(req, obj) {
                return function() {
                    if(req.request.readyState == 4){

                        const url = req.request.response;
                        obj.appHeader.getTemplateViewModel().defaultSettingsUrl(url);
                    }
                }
            });
            XHRHdl.execute();

            this.getReleaseLogs();
        }
    }

    private getReleaseLogs(){

        this.XHRHdl = new XMLHttpRequestHandler('/api/releaseNotes/', [], this);
        this.XHRHdl.onReadyStateFunction = this.onGetReleaseLogs;
        this.XHRHdl.execute();
    }

    private onGetReleaseLogs(req, obj){

        return function(){

            obj.manageResponse(req, obj, function(){

                let releaseLogs = JSON.parse(req.request.response);

                if (releaseLogs) {

                    obj.processReleaseLogs(releaseLogs);
                }
            });
        }
    }

    public logOut(){
        // loading the page if the user is logged in
        let loginReq_url: string = '/api/access/logout/';
        let loginReq_Params: Array<Array<string>> = [];

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(loginReq_url,loginReq_Params, this);
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function(){

                if (req.request.readyState == 4) {

                    if(  req.request.status == 200  ){
                        page.redirect('/');
                    }
                }
            }
        });
        XHRHdl.execute();
    }

    public isOfRole(role: Number) {
        let show = false;

        let vnApp = this.getVnAppZone().app;
        let roles: Array<any> = vnApp.loggedUser.user.vnAppUser.roles;
        let roleIds = [];

        for (let role of roles) {
            roleIds.push(role.id);
        }
        if (roleIds.indexOf(role) > -1) {
            show = true;
        }

        return show;
    }

    public setHeaderTitle(title: string){}

    private changeDeviceView(device) {

        this.getVnAppZone().addCookie('deviceView', device);
        location.reload();
    }

    protected showPlanPromo(){

        const cookie = this.getVnAppZone().getCookie('showPlanPromo');
        if(!cookie) return;

        const planPromoCount = Number.parseInt(cookie);

        // basically, every 100 report loads (backend getReferences increments this value), show the plan promotion message.
        if (planPromoCount >= 100) {

            this.appHeader.setShowPlanPromo(true);
        }
    }

    protected clearPlanPromo(){
        
        this.appHeader.setShowPlanPromo(false);
        this.getVnAppZone().addCookie('showPlanPromo', 0);
    }

    protected redirectToSubscriptionManagement(){

        this.appHeader.setShowPlanPromo(false);
        page.redirect('/subscription_management/');
    }
}



// WEBPACK FOOTER //
// ./js/modules/header.ts